module.exports = __webpack_public_path__ + "img/gmyb.f5cc6787.png";